(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
const items = document.querySelectorAll('.product-grid-item');
items.forEach(item => {
  const button = item.querySelector('.form-btn-wrapper');
  const info = item.querySelector('.product__grid__info');
  
  if (button && info) {
    const buttonClone = button.cloneNode(true);
    info.after(buttonClone);
    button.remove();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
const items = document.querySelectorAll('.product-grid-item');
items.forEach(item => {
  const button = item.querySelector('.form-btn-wrapper');
  const info = item.querySelector('.product__grid__info');
  
  if (button && info) {
    const buttonClone = button.cloneNode(true);
    info.after(buttonClone);
    button.remove();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection"] && !Shopify.designMode) return;
  try {
    
const items = document.querySelectorAll('.product-grid-item');
items.forEach(item => {
  const button = item.querySelector('.form-btn-wrapper');
  const info = item.querySelector('.product__grid__info');
  
  if (button && info) {
    const buttonClone = button.cloneNode(true);
    info.after(buttonClone);
    button.remove();
  }
});

  } catch(e) { console.error(e); }
})();
})();
